import React from 'react';
import { motion } from 'framer-motion';
import { GoldRule } from './GoldRule';
import { serviceCategories } from './data';
import { CategoryBanner, ServiceThumb } from './ServiceMedia';
export function Services() {
  return <section id="servicios" className="max-w-2xl mx-auto px-6 scroll-mt-24" data-id="element-346" data-mp="1dspuoeeiawit">
      <GoldRule data-id="element-347" data-mp="18vr1pz6kwvm7">Nuestros Servicios</GoldRule>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7
    }} data-id="element-348" data-mp="18uody04jz9ai">
        <p className="font-body font-semibold text-[11px] tracking-[5px] uppercase text-gold mb-3" data-id="element-349" data-mp="z3bikyjjq0zq">
          Menú Completo de Servicios
        </p>
        <h2 className="font-serif text-dark text-3xl sm:text-4xl leading-tight mb-4" data-id="element-350" data-mp="q5hozvd61lg9">
          Todo lo que necesitas,
          <br data-id="element-351" data-mp="l4tx77h450kz" />
          <em className="italic text-gold" data-id="element-352" data-mp="l7g5587x1i3q">en un solo lugar.</em>
        </h2>
        <p className="font-body font-light text-mid text-sm leading-[1.85] mb-10" data-id="element-353" data-mp="g6sj70yjnrgd">
          Cada servicio es diseñado específicamente para ti, con productos de alta calidad y
          técnicas de vanguardia. Sin importar dónde te encuentres — si estás en Queens o llegas
          desde otra ciudad — tu experiencia aquí será impecable.
        </p>
      </motion.div>

      <div className="space-y-10" data-id="element-354" data-mp="32a325qok2o9g">
        {serviceCategories.map((cat, ci) => {
        const Icon = cat.icon;
        return <motion.div key={cat.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: ci * 0.05
        }} data-id="element-355" data-mp="3q1rwtdounotk" data-mpi={ci}>
              <div className="flex items-center gap-4 pb-3 mb-4 border-b border-brand-border" data-id="element-356" data-mp="3kzswydsbja1d">
                <span className="metallic-gold-surface w-12 h-12 rounded-full border border-metallic-border flex items-center justify-center flex-shrink-0 shadow-[0_3px_10px_rgba(183,144,72,0.28)]" data-id="element-357" data-mp="24lj71f8fhd8f">
                  <Icon className="w-6 h-6 text-white drop-shadow-[0_1px_1px_rgba(73,53,20,0.35)]" strokeWidth={1.7} data-id="element-358" data-mp="1pjktjrmdt3bx" />
                </span>
                <h3 className="font-serif text-dark text-xl sm:text-2xl tracking-wide" data-id="element-359" data-mp="1grshxdlmfo5r">
                  {cat.name}
                </h3>
              </div>

              {cat.image && <CategoryBanner src={cat.image} alt={cat.imageAlt ?? cat.name} label={cat.name} data-id="element-360" data-mp="1bqld9nerz53b" />}

              <div data-id="element-361" data-mp="16ri69xf8iosp">
                {cat.items.map(item => <div key={item.name} className="group flex justify-between items-start gap-4 sm:gap-5 py-3.5 border-b border-brand-border/40 last:border-b-0" data-id="element-362" data-mp="11u05wvfa9hwb">
                    {item.image && <ServiceThumb src={item.image} alt={item.name} data-id="element-363" data-mp="sttm6rszrlop" />}
                    <div className="flex-1" data-id="element-364" data-mp="svo5y2sj17r7">
                      <div className="font-body font-medium text-dark text-sm mb-1 tracking-[0.3px]" data-id="element-365" data-mp="2s7h80du693as">
                        {item.name}
                      </div>
                      <div className="font-body font-light text-soft text-xs leading-[1.6]" data-id="element-366" data-mp="2n5ry51ioqvoa">
                        {item.desc}
                      </div>
                    </div>
                    <div className="text-right min-w-[90px] pt-0.5" data-id="element-367" data-mp="2zom4izmswsnf">
                      <div className="font-serif font-medium text-champagne-deep text-lg whitespace-nowrap" data-id="element-368" data-mp="34i869wrffc4g">
                        {item.price}
                      </div>
                      {item.note && <span className="block font-body font-light text-soft text-[10px] mt-0.5" data-id="element-369" data-mp="2btb0uu8bd9t4">
                          {item.note}
                        </span>}
                    </div>
                  </div>)}
              </div>
            </motion.div>;
      })}
      </div>
    </section>;
}